<template>
  <div class="pc_top">
    <div class="pc_main">
      <router-link to="/">
        <img class="pc_top_logo" src="@/assets/logo.png" alt="">
      </router-link>
      <div class="pc_top_name" v-show="isShowHHTX">无悠网络</div>
      <div class="pc_top_links">
        <router-link :to="item.router" v-for="item in menus" :key="item.title">{{item.title}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import tools from '@/tools/tools'

export default {
  name: 'TopPc',
  components: {
  },
  data: () => {
    return {
      isShowMenu: false,

      menus: [
        {
          title: '首页',
          router: '/'
        }, {
          title: '隐私保护',
          router: '/ys'
        }, {
          title: '用户协议',
          router: '/xy'
        }, {
          title: '客服中心',
          router: '/service'
        }, {
          title: '关于我们',
          router: '/us'
        }
      ]
    }
  },
  methods: {

  },
  computed: {
    isShowHHTX () {
      return true// tools.isMac()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pc_top {
  position: fixed;
  height: 64px;
  background: rgba(255, 255, 255, 0.9);
  right: 0;
  top: 0;
  left: 0;
  z-index: 99999;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.1);
}
.pc_main {
  width: 1200px;
  margin: auto;
  position: relative;
}
.pc_top_logo {
  position: absolute;
  left: 60px;
  top: 14px;
  height: 38px;
}
.pc_top_links {
  line-height: 64px;
  position: absolute;
  left: 340px;
}
.pc_top_links a {
  border-top: 2px rgba(0, 0, 0, 0) solid;
  padding: 18px 1px;
  margin: 0 18px;
  color: #666666;
  font-size: 14px;
  text-decoration: none;
}
.pc_top_links a:hover {
  color: #37a1ff;
}
.pc_top_links .router-link-exact-active {
  border-top: 2px #37a1ff solid;
  color: #37a1ff;
}
.pc_top_name {
  position: absolute;
  left: 10rem;
  top: 1.2rem;
  font-weight: bold;
  color: rgba(0,0,0,0.3);
}
</style>
